export function devOnly() {
  return (
    import.meta.env.REACT_APP_PROJECT_ID === "wombat-development" ||
    window?.location.hostname === "localhost"
  );
}
